"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// lightly adapted from https://github.com/0xProject/0x-monorepo/pull/1431
// TODO replace with offical implementation when TrezorSubprovider gets added to 0x/subproviders
// TODO add event listeners per https://github.com/trezor/connect/blob/develop/docs/events.md ?
var subproviders_1 = require("@0x/subproviders");
var connector_1 = __importDefault(require("../connector"));
var subprovider_1 = __importDefault(require("./subprovider"));
var TrezorConnector = /** @class */ (function (_super) {
    __extends(TrezorConnector, _super);
    function TrezorConnector(kwargs) {
        var _this = this;
        var TrezorConnect = kwargs.api, supportedNetworkURLs = kwargs.supportedNetworkURLs, defaultNetwork = kwargs.defaultNetwork, manifestEmail = kwargs.manifestEmail, manifestAppUrl = kwargs.manifestAppUrl;
        var supportedNetworks = Object.keys(supportedNetworkURLs).map(function (supportedNetworkURL) { return Number(supportedNetworkURL); });
        _this = _super.call(this, { supportedNetworks: supportedNetworks }) || this;
        _this.TrezorConnect = TrezorConnect;
        _this.supportedNetworkURLs = supportedNetworkURLs;
        _this.defaultNetwork = defaultNetwork;
        _this.manifestEmail = manifestEmail;
        _this.manifestAppUrl = manifestAppUrl;
        return _this;
    }
    TrezorConnector.prototype.onActivation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.TrezorConnect.manifest({
                    appUrl: this.manifestAppUrl,
                    email: this.manifestEmail
                });
                return [2 /*return*/];
            });
        });
    };
    TrezorConnector.prototype.getProvider = function (networkId) {
        return __awaiter(this, void 0, void 0, function () {
            var networkIdToUse, trezorSubprovider, engine;
            return __generator(this, function (_a) {
                networkIdToUse = networkId || this.defaultNetwork;
                _super.prototype._validateNetworkId.call(this, networkIdToUse);
                trezorSubprovider = new subprovider_1.default({
                    accountFetchingConfigs: { numAddressesToReturn: 1 },
                    networkId: networkIdToUse,
                    trezorConnectClientApi: this.TrezorConnect
                });
                engine = new subproviders_1.Web3ProviderEngine();
                this.engine = engine;
                engine.addProvider(trezorSubprovider);
                engine.addProvider(new subproviders_1.RPCSubprovider(this.supportedNetworkURLs[networkIdToUse]));
                engine.start();
                return [2 /*return*/, engine];
            });
        });
    };
    TrezorConnector.prototype.onDeactivation = function () {
        if (this.engine) {
            this.engine.stop();
        }
    };
    TrezorConnector.prototype.changeNetwork = function (networkId) {
        // proactively handle wrong network errors
        try {
            _super.prototype._validateNetworkId.call(this, networkId);
            _super.prototype._web3ReactUpdateHandler.call(this, { updateNetworkId: true, networkId: networkId });
        }
        catch (error) {
            _super.prototype._web3ReactErrorHandler.call(this, error);
        }
    };
    return TrezorConnector;
}(connector_1.default));
exports.default = TrezorConnector;
//# sourceMappingURL=index.js.map